import { render, staticRenderFns } from "./ClipboardBtn2.vue?vue&type=template&id=aa79d284&scoped=true"
import script from "./ClipboardBtn2.vue?vue&type=script&lang=js"
export * from "./ClipboardBtn2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa79d284",
  null
  
)

export default component.exports